function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "product_surface-curtain");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.141 24.357v-17.999c0-0.772-0.514-1.286-1.285-1.286h-9v23.141h11.567v1.286h-12.852v-24.427h-5.143v24.427h-1.289v-24.427h-8.996c-0.771 0-1.285 0.514-1.285 1.286v21.855h6.428c0.771 0 1.285 0.514 1.285 1.286h-8.999v-24.427c0.004-1.418 1.153-2.567 2.571-2.571h25.715c1.418 0.004 2.567 1.153 2.571 2.571v20.57c-0.774 0-1.288-0.514-1.288-1.285z"
});

var SvgProductSurfaceCurtain = function SvgProductSurfaceCurtain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProductSurfaceCurtain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product_surface-curtain.9bd607b7.svg";
export { ForwardRef as ReactComponent };